import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarSecuencia = async (secuencia) => {
    const configs = { headers: getHeaders() };

    try {
        if (secuencia.id !== "") {
            const resp = await axios.put(
                `${API_URL}/secuencias/${secuencia.id}`,
                secuencia,
                configs
            );
            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/secuencias`,
            secuencia,
            configs
        );
        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarSecuencia = async (id) => {
    try {
        const resp = await axios.delete(`${API_URL}/secuencias/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarSecuencia = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/secuencias/activar/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const asignarSecuencia = async (secuenciaId, empleados) => {
    try {
        const resp = await axios.post(
            `${API_URL}/secuencias/${secuenciaId}/asignar`,
            { asignaciones: empleados },
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerSecuenciaPorId = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/secuencias/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
